import {useQuery} from '@tanstack/react-query';
import {stringComparator} from 'app/util/Sort';
import {UnifyBillingApi, unifyBillingMapper} from 'app/components/entities/billing/unify';

interface Args {
  enabled: boolean;
  teamId: string;
}

export function useUnifyTiers({enabled, teamId}: Args) {
  return useQuery({
    queryKey: ['billing', 'unify', 'tiers', teamId],
    enabled,
    queryFn: async () => {
      const res = await UnifyBillingApi.getTiers();
      return res.map(unifyBillingMapper.mapUnifyTier).sort((a, b) => stringComparator(b.id, a.id));
    },
  });
}
